import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { WhatsAppFab } from "../components/Extras";
import { useConfig } from "../lib/useConfig";
import { buildWhatsAppUrl } from "../data/content";

export default function BlogIndex() {
    const config = useConfig();
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        document.title = "Consejos LoloPets | Cuidado de aves, conejos y roedores";
        axios
            .get(`${process.env.REACT_APP_BACKEND_URL}/api/blog`)
            .then((r) => setPosts(r.data))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    return (
        <div data-testid="blog-index" className="min-h-screen bg-white">
            <Header base="/" />
            <main className="mx-auto max-w-7xl px-4 py-12 sm:px-6 md:py-16 lg:px-8">
                <p className="text-sm font-bold uppercase tracking-widest text-brand-magenta">Consejos LoloPets</p>
                <h1 className="mt-3 font-display text-3xl font-bold tracking-tight text-brand-ink sm:text-4xl">
                    Aprende a cuidar mejor a tu mascota
                </h1>
                {loading ? (
                    <div className="mt-10 grid gap-6 md:grid-cols-3">
                        {[0, 1, 2].map((i) => (
                            <div key={i} className="animate-pulse rounded-2xl bg-black/[0.04] shadow-soft">
                                <div className="aspect-[4/3]" />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                        {posts.map((post) => (
                            <Link
                                key={post.slug}
                                data-testid={`blog-index-card-${post.slug}`}
                                to={`/blog/${post.slug}`}
                                className="group flex h-full flex-col overflow-hidden rounded-2xl border border-black/5 bg-white shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-lift"
                            >
                                <div className="overflow-hidden bg-black/[0.03]">
                                    {post.image && (
                                        <img
                                            src={post.image}
                                            alt={post.title}
                                            loading="lazy"
                                            className={`aspect-[4/3] w-full transition-transform duration-500 group-hover:scale-105 ${post.image?.includes("/v1/fit/") ? "object-contain p-4" : "object-cover"}`}
                                        />
                                    )}
                                </div>
                                <div className="flex flex-1 flex-col p-6">
                                    <h2 className="font-display text-lg font-semibold leading-snug text-brand-ink transition-colors duration-200 group-hover:text-brand-magenta">
                                        {post.title}
                                    </h2>
                                    <p className="mt-2 flex-1 text-sm leading-relaxed text-brand-muted">{post.excerpt}</p>
                                    <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-magenta">
                                        Leer consejo <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
                                    </span>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </main>
            <Footer base="/" config={config} />
            <WhatsAppFab url={buildWhatsAppUrl(config?.whatsapp)} />
        </div>
    );
}
